export enum OrderStatus {
  Pending = 'pending',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}

export type TOrderStatus = OrderStatus.Pending | OrderStatus.Completed | OrderStatus.Cancelled;
